import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom"; // Import useNavigate and useLocation for routing
import { motion } from "framer-motion";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import useAnimatedNavToggler from "../../helpers/useAnimatedNavToggler.js";
import logo from "../../images/logo white.png";
import { ReactComponent as MenuIcon } from "feather-icons/dist/icons/menu.svg";
import { ReactComponent as CloseIcon } from "feather-icons/dist/icons/x.svg";
import { useTranslation } from 'react-i18next';
// Styled Components
const Header = tw.header`
  flex justify-between items-center max-w-screen-xl mx-auto mt-[30px] mb-[40px]
`;

export const NavLinks = tw.div`flex items-center gap-2	`;

export const NavLink = tw.a`
  text-lg my-2 lg:text-sm lg:mx-6 lg:my-0
  font-semibold tracking-wide transition duration-300
  pb-1 border-b-2 border-transparent hover:border-[#133b8c] hocus:text-[#133b8c]
`;


export const PrimaryLink = tw(NavLink)`
  lg:mx-0
  px-8 py-3 rounded bg-[#133b8c] text-gray-100
  hocus:bg-[#133b8c] hocus:text-gray-200 focus:shadow-outline
  border-b-0
`;


export const LogoLink = styled(NavLink)`
  ${tw`flex items-center font-black border-b-0 text-2xl! ml-0!`};

  img {
    width: 130px; /* Set your desired width */
    height: auto; /* Maintain aspect ratio */
    ${tw`mr-3`} /* Tailwind margin right */
  }
`;

const MobileNavLinksContainer = tw.nav`
  flex flex-1 items-center justify-between lg:hidden
`
export const NavToggle = tw.button`
  lg:hidden z-20 focus:outline-none hocus:text-primary-500 transition duration-300
`;
const MobileNavLinks = motion(styled.div`
  position: absolute;
  top: 170 px; // 👈 Reduced spacing
  right: 0;
  width: 16rem;
  padding: 1.5rem;
  background-color: white;
  color: #1f2937;
  border-radius: 0.5rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  z-index: 50;
`);
// MobileNavLinksList removed (unused)
export const DesktopNavLinks = tw.nav`
  hidden lg:flex flex-1 justify-between items-center
`;

// DropdownMenu removed - not used in simplified sidebar


// Styled NavLink for Dropdown with Hover Color
export const NavLinkStyled = styled(NavLink)`
  ${tw`block px-4 py-2 text-gray-800 transition-colors duration-300`};
  &:hover {
    background-color: #133b8c; /* Ajoute le fond bleu personnalisé */
    color: white; /* Change la couleur du texte pour plus de visibilité */
  }
`;



export const UserButton = styled.button`
  ${tw`relative px-4 py-2 rounded-full bg-[#133b8c] text-white font-semibold mr-4 transition duration-300`};
  &:hover {
    background-color: #1e3d56; /* Nouvelle couleur au survol */
    color: #ffffff; /* Texte blanc */
  }
  &:focus {
    ${tw`outline-none`};
  }
`;


export default ({
  roundedHeaderButton = false,
  logoLink,
  links,
  className,
  collapseBreakpointClass = "lg",
}) => {
  const { t } = useTranslation();
  const { showNavLinks, animation, toggleNavbar } = useAnimatedNavToggler();
  const collapseBreakpointCss = collapseBreakPointCssMap[collapseBreakpointClass];

  // user info (for logout/profile) ------------------------------------------------
  const [user, setUser] = useState(() => {
    try {
      const raw = localStorage.getItem('user');
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  });

  const handleLogout = () => {
    // Clear user session data
    localStorage.removeItem('user'); // Clear user data from localStorage
    localStorage.removeItem('authToken'); // Optionally remove authToken or other info
    localStorage.removeItem('id');
    localStorage.removeItem('isAdmin');
    localStorage.removeItem('role');

    setUser(null);
    // Reset the user state and fallback role
    localStorage.setItem('role', "supplier"); // Store admin status

    navigate('/'); // Redirect to the home page
  };


  const navigate = useNavigate(); // Use navigate for redirection
  const location = useLocation(); // Use location from react-router (avoid global `location`)

  // (previous user/account logic removed for simplified sidebar)

  // logout handler omitted for sidebar simplicity

  // Build a vertical menu for desktop (sidebar style)
  const menuItems = [
    { path: '/dashbord-gestion', label: t('Dashboard'), icon: '📊' },
    { path: '/RapportPerformance', label: t('RapportPerformance'), icon: '🧾' },

    { path: '/Caisse', label: t('Caise'), icon: '💳' },
    { path: '/Gestion_Produit', label: t('Produits'), icon: '📦' },
    { path: '/Edit-stock', label: t('EditStock'), icon: '📥' },
    { path: '/Edit-price', label: t('EditPrice'), icon: '💰' },
    { path: '/clientgestions', label: t('Clients'), icon: '👥' },
    { path: '/gestion-credit', label: t('Gestion credits'), icon: '💳' },
    { path: '/historique', label: t('Historique'), icon: '🕘' },
    { path: '/facturations', label: t('Facturations'), icon: '🧾' },
    { path: '/devis', label: t('Devis'), icon: '🧾' },
    { path: '/Bon', label: t('Bon'), icon: '🧾' },
    { path: '/parametres', label: t('Paramètres'), icon: '⚙️' },
  ];

  const defaultLogoLink = (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <img src={logo} alt="logo" style={{ width: 140, height: 70, marginBottom: 12 

      }} />
    </div>
  );

  logoLink = logoLink || defaultLogoLink;
  // links are unused in sidebar layout

  return (
    <>
      {/* Desktop: fixed vertical sidebar */}
      <div className="hidden lg:block" style={{ position: 'fixed', left: 0, top: 0, bottom: 0, zIndex: 999 }}>
        <div style={{ width: 260, background: '#0e2433', color: '#fff', borderRadius: '0 12px 12px 0', padding: '28px 18px', display: 'flex', flexDirection: 'column', gap: 14, height: '100vh', boxShadow: '2px 0 8px rgba(2,6,23,0.25)' }}>
          <div style={{ display: 'flex', justifyContent: 'center' }}>{defaultLogoLink}</div>

          {/* Make the nav area scrollable when it overflows. Keep logo at top and user area fixed at bottom. */}
          <nav className="sidebar-nav" style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 6, flex: 1, paddingRight: 6, overflowY: 'auto' }}>
            {menuItems.map(item => {
              const active = location.pathname === item.path || location.pathname.startsWith(item.path + '/');
              return (
                <a
                  key={item.path}
                  onClick={(e) => { e.preventDefault(); navigate(item.path); }}
                  href={item.path}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 12,
                    padding: '12px 14px',
                    borderRadius: 10,
                    textDecoration: 'none',
                    color: active ? '#0b1220' : '#d1d5db',
                    background: active ? '#3b82f6' : 'transparent',
                    fontWeight: active ? 700 : 600,
                    boxShadow: active ? '0 6px 18px rgba(59,130,246,0.12)' : 'none'
                  }}
                >
                  <div style={{ width: 36, height: 36, borderRadius: 8, background: active ? '#fff' : '#0b1224', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>
                    <span>{item.icon}</span>
                  </div>
                  <div style={{ flex: 1 }}>{item.label}</div>
                </a>
              );
            })}
          </nav>
          {/* user/logout area */}
          <div style={{ marginTop: 'auto' }}>
            {user ? (
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 12 }}>
                <div style={{ color: '#d1d5db', fontWeight: 700 }}>{user.name}</div>
                <button onClick={handleLogout} style={{ background: '#fff', color: '#0e2433', borderRadius: 8, padding: '6px 10px', border: 'none', cursor: 'pointer' }}>      {t('Déconnexion')}
</button>
              </div>
            ) : (
              <div style={{ marginTop: 12 }}>
                <a href="/login" onClick={(e) => { e.preventDefault(); navigate('/login'); }} style={{ color: '#d1d5db' }}>Connexion</a>
              </div>
            )}
          </div>
        </div>
      </div>

  {/* Spacer so the page content flows to the right of the fixed sidebar on large screens */}
  <div className="hidden lg:block" style={{ width: 260, minHeight: '1px', flexShrink: 0 }} />

      {/* Mobile: keep existing mobile nav */}
      <div className="lg:hidden">
        <Header className={className || "header-light"}>
          <MobileNavLinksContainer css={collapseBreakpointCss.mobileNavLinksContainer}>
            {logoLink}
            <MobileNavLinks
              initial={{ x: "150%", display: "none" }}
              animate={animation}
              css={collapseBreakpointCss.mobileNavLinks}
            >
              {links}
            </MobileNavLinks>
            <NavToggle onClick={toggleNavbar} className={showNavLinks ? "open" : "closed"}>
              {showNavLinks ? <CloseIcon tw="w-6 h-6" /> : <MenuIcon tw="w-6 h-6" />}
            </NavToggle>
          </MobileNavLinksContainer>
        </Header>
      </div>
    </>
  );
};

// Breakpoint mappings for different screen sizes
const collapseBreakPointCssMap = {
  sm: {
    mobileNavLinks: tw`sm:hidden`,
    desktopNavLinks: tw`sm:flex`,
    mobileNavLinksContainer: tw`sm:hidden`,
  },
  md: {
    mobileNavLinks: tw`md:hidden`,
    desktopNavLinks: tw`md:flex`,
    mobileNavLinksContainer: tw`md:hidden`,
  },
  lg: {
    mobileNavLinks: tw`lg:hidden`,
    desktopNavLinks: tw`lg:flex`,
    mobileNavLinksContainer: tw`lg:hidden`,
  },
  xl: {
    mobileNavLinks: tw`lg:hidden`,
    desktopNavLinks: tw`lg:flex`,
    mobileNavLinksContainer: tw`lg:hidden`,
  },
};
